import { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom"
import {
  Banner,
  BannerBrandSuite,
  BannerBrandLogo,
  BannerBrandInline,
  BannerRight,
  ButtonGroup,
  BannerActionBarItem,
  ButtonField,
  Iconsvg,
  DropdownMoreButton,
  Dropdown,
  DropdownList,
  DropdownListItem,
  Tag,
} from "@wk/components-react16"
import { useMsal } from "@azure/msal-react"
import Profile from '../profile/Profile';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import AuthService from "../../config/auth/auth.service";

import SelectProject from '../project-management/SelectProject';
import { Privilege } from '../../config/constants/privilege';

const Header = () => {
  const navigate = useNavigate();
  const { instance } = useMsal();
  const [isRefresh, setIsRefresh] = useState(true);
  const { authUser, authProject } = useSelector((state: RootState) => state.auth);
  const [isOpenProfile, setIsOpenProfile] = useState(false);
  const [isOpenSelectProject, setIsOpenSelectProject] = useState(false);

  const handleProfile = async () => {
    setIsOpenProfile(true);
  }

  const handleLogout = async () => {
    AuthService.logout(navigate, instance);
  }

  /* const handlePassword = async () => {
    navigate("/changepassword");
  }
 */
  const handleUserManagement = async () => {
    navigate("/usermanagement");
  }

  const handleProjectManagement = async () => {
    navigate("/projectmanagement");
  }

  const handleUserActivityLog = async () => {
    navigate("/useractivitylog");
  }



  useEffect(() => {
    const refreshOnLoad = async () => {
      const token = await AuthService.refreshToken();
      if (!token || !token.token) {
        console.log('Token expired');
        handleLogout();
      }
    };
    if (isRefresh) {
      refreshOnLoad();
    }
    setIsRefresh(false);

    const intervalId = setInterval(() => {
      refreshOnLoad();
    }, 600000); // 10 minutes in milliseconds

    return () => clearInterval(intervalId);
  }, [isRefresh]);

  const isEmptyObject = (obj: any) =>
    obj && typeof obj === 'object' && Object.keys(obj).length === 0;

  useEffect(() => {
    if (!authProject || isEmptyObject(authProject)) {
      setIsOpenSelectProject(true);
    }
  }, [authProject]);

  // console.log("User Privileges:", authUser?.privileges);

  return (
    <div className="cg-story">
      <Banner isSticky={true}>
        <BannerBrandSuite
          href="#"
          isPreventDefault
          srLabel="Go to Wolters Kluwer Product X home page"
          slot="bannerBrandSuite"
        >
          <BannerBrandLogo slot="bannerBrandLogo"></BannerBrandLogo>
          <BannerBrandInline
            productName="Content Rocket"
            slot="bannerBrand"
          ></BannerBrandInline>
        </BannerBrandSuite>
        <BannerRight slot="bannerRight">
          <ButtonGroup dropdownToggleMode="gray">
            <BannerActionBarItem slot="buttonGroupItem">
              <span className="custom-tag cursor-pointer mr-10" onClick={() => setIsOpenSelectProject(true)}>
                <Tag color="orange" contrastMode="light">{authProject && authProject.name ? `Select Project: ${authProject.name}` : 'Select Project'} {' '}<Iconsvg name="chevron-down" size={14}></Iconsvg></Tag>
              </span>
              <ButtonField mode={'text'} size={'small'} iconPosition={'left'}>
                <button className='p-0'
                  type="button"
                  onClick={handleProfile}>
                  <Iconsvg name="user"></Iconsvg>
                  {authUser?.username}
                </button>
              </ButtonField>
              <DropdownMoreButton
                mode="blue"
                buttonId="button2"
              ></DropdownMoreButton>
              <Dropdown
                targetSelector="#button2"
                menuMode="application"
                srLabelledby="button2"
              >
                <DropdownList menuMode="application">
                  {authUser?.privileges.includes(Privilege[Privilege.VIEW_PROJECT_MANAGEMENT]) && (
                    <DropdownListItem
                      slot="dropdownListItem"
                      onItemClick={handleProjectManagement}
                    >
                      <Iconsvg name="folder-stack"></Iconsvg>
                      Project Management
                    </DropdownListItem>
                  )}
                  {authUser?.privileges.includes(Privilege[Privilege.USER_MANAGEMENT]) && (
                    <>
                    <DropdownListItem
                      slot="dropdownListItem"
                      onItemClick={handleUserManagement}
                    >
                      <Iconsvg name="user"></Iconsvg>
                      User Management
                    </DropdownListItem>
                    <DropdownListItem
                      slot="dropdownListItem"
                      onItemClick={handleUserActivityLog}
                    >
                      <Iconsvg name="list-bullet-dot"></Iconsvg>
                      User Action Log
                    </DropdownListItem>
                    </>
                  )}
                  
                  {/* <DropdownListItem
                    slot="dropdownListItem"
                    onItemClick={handlePassword}
                  >
                    <Iconsvg name="key"></Iconsvg>
                    Change Password
                  </DropdownListItem> */}
                  <DropdownListItem
                    slot="dropdownListItem"
                    onItemClick={handleLogout}
                  >
                    <Iconsvg name="logout"></Iconsvg>
                    Logout
                  </DropdownListItem>
                </DropdownList>
              </Dropdown>
            </BannerActionBarItem>
          </ButtonGroup>
        </BannerRight>
      </Banner>
      {isOpenProfile && <Profile data={{ isOpenProfile, setIsOpenProfile }} />}
      {isOpenSelectProject && <SelectProject data={{ isOpenSelectProject, setIsOpenSelectProject }} />}
    </div>
  )
}
export default Header;
